"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _md = _interopRequireDefault(require("md5"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(assignmentId) {
  var someRandomString = 'shdfhgjkhkjr234j23hjk4hkj23h4k2';
  return (0, _md["default"])(someRandomString + String(assignmentId).repeat(5)).substring(0, 7);
};